<template>
  <footer class="ftco-footer ftco-section img">
    <div class="overlay"></div>
    <div class="container">
      <div class="row mb-5">
        <div class="col-lg-3 col-md-6 mb-5 mb-md-5">
          <div class="ftco-footer-widget mb-4">
            <h2 class="ftco-heading-2">About Us</h2>
            <p>
              We share the variety and wonderful taste of Uyghur cuisine with
              its ancient origins and we will be happy with it!
            </p>
            <ul
              class="
                ftco-footer-social
                list-unstyled
                float-md-left float-lft
                mt-5
              "
            >
              <li class="ftco-animate">
                <a><span class="icon-twitter"></span></a>
              </li>
              <li class="ftco-animate">
                <a><span class="icon-facebook"></span></a>
              </li>
              <li class="ftco-animate">
                <a><span class="icon-instagram"></span></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-5 mb-md-5">
          <div class="ftco-footer-widget mb-4">
            <h2 class="ftco-heading-2">Recent News</h2>
            <div class="block-21 mb-4 d-flex">
              <a
                class="blog-img mr-4"
                style="background-image: url(images/image_1.jpg)"
              ></a>
              <div class="text">
                <h3 class="heading">
                  <a>Even the all-powerful Pointing has no control about</a>
                </h3>
                <div class="meta">
                  <div>
                    <a><span class="icon-calendar"></span> Sept 15, 2021</a>
                  </div>
                  <div>
                    <!--                    <a ><span class="icon-person"></span> Admin</a>-->
                  </div>
                  <div>
                    <a><span class="icon-chat"></span> 19</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="block-21 mb-4 d-flex">
              <a
                class="blog-img mr-4"
                style="background-image: url(images/image_2.jpg)"
              ></a>
              <div class="text">
                <h3 class="heading">
                  <a>Even the all-powerful Pointing has no control about</a>
                </h3>
                <div class="meta">
                  <div>
                    <a><span class="icon-calendar"></span> Sept 15, 2021</a>
                  </div>
                  <div>
                    <!--                    <a ><span class="icon-person"></span> Admin</a>-->
                  </div>
                  <div>
                    <a><span class="icon-chat"></span> 19</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 mb-5 mb-md-5">
          <div class="ftco-footer-widget mb-4 ml-md-4">
            <h2 class="ftco-heading-2">Services</h2>
            <ul class="list-unstyled">
              <li><a class="py-2 d-block">Cooked</a></li>
              <li><a class="py-2 d-block">Deliver</a></li>
              <li><a class="py-2 d-block">Quality Foods</a></li>
              <li><a class="py-2 d-block">Mixed</a></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 mb-5 mb-md-5">
          <div class="ftco-footer-widget mb-4">
            <h2 class="ftco-heading-2">Have a Questions?</h2>
            <div class="block-23 mb-3">
              <ul>
                <li>
                  <span class="icon icon-map-marker"></span
                  ><span class="text"
                    >1141 Brighton Beach Ave, Brooklyn, NY 11235, USA</span
                  >
                </li>
                <li>
                  <a
                    ><span class="icon icon-phone"></span
                    ><span class="text"> (718) 743-3832</span></a
                  >
                </li>
                <li>
                  <a
                    ><span class="icon icon-envelope"></span
                    ><span class="text">infokashkarcafe@gmail.com</span></a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <p>
            Copyright &copy;{{ new Date().getFullYear() }} All rights reserved
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  methods: {},
};
</script>

<style scoped></style>
